module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"no-title":"_(No title)_"},"fr_FR":{"no-title":"_(Aucun titre)_"}}')
  delete Component.options._Ctor
}
